// import http from 'axios';

const API = {
  // 登录
  login (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/login`,
      method: 'POST',
      data
    })
  },
  //忘记密码
  forgotPwd (data) {
    return window.axios({
      url: `/merchant/ekyc/forgotPwd`,
      method: 'POST',
      data
    })
  },

  // 新增商户
  addBdoMerchant (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/addEkyc2Mch`,
      method: 'POST',
      data,
    })

  },

  // 新建流程
  addBdoProcess (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/addProcess`,
      method: 'POST',
      data,
    })

  },

  // 编辑流程
  editBdoProcess (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/editProcess`,
      method: 'POST',
      data,
    })

  },

  // 获取流程
  getBdoProcessData (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/detailsProcess`,
      method: 'POST',
      data,
    })

  },

  // 选择流程
  chooseBdoProcess (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/chooseProcess`,
      method: 'POST',
      data,
    })

  },

  // 确认流程
  confirmBdoProcess (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/confirmProcess`,
      method: 'POST',
      data,
    })

  },

  // 图片上传
  uploadPic (data) {
    console.log("this....", this)
    return window.axios({
      url: `/cms/ekyc2/image/privateCloudUploadImg`,
      method: 'POST',
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data,
      silence: true,
    })
  },

  //单页新增/编辑
  saveOrUpdatePage (data) {
    return window.axios({
      url: `/merchant/ekyc/saveOrUpdatePage`,
      method: 'POST',
      data
    })
  },

  //单页查询
  getPageInfo (data) {
    return window.axios({
      url: `/merchant/ekyc/getPageInfo`,
      method: 'POST',
      data
    })
  },

  //页面汇总查询
  getAllPage (data) {
    return window.axios({
      url: `/merchant/ekyc/getAllPage`,
      method: 'POST',
      data
    })
  },

  //流程确认提交
  confirm (data) {
    return window.axios({
      url: `/merchant/ekyc/confirm`,
      method: 'POST',
      data
    })
  },

  //忘记密码发送邮件
  sendEmail (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/sendEmail`,
      method: 'POST',
      data
    })
  },

  //忘记密码发送邮件
  sendVerifycode (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/sendVerifycode`,
      method: 'POST',
      data
    })
  },

  //忘记密码验证验证码
  verifycode (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/verifycode`,
      method: 'POST',
      data
    })
  },

  //忘记密码修改密码
  modifyPassword (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/modifyPassword`,
      method: 'POST',
      data
    })
  },

  // 获取系统时间接口
  getLocalDate (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/getLocalDate`,
      method: 'POST',
      data,
    })
  },

  // 发送OTP
  sendOtp (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/sendOtp`,
      method: 'POST',
      data,
    })
  },

  // 验证OTP
  verifyOtp (data) {
    return window.axios({
      url: `/cms/ekyc2/h5/verifyOtp`,
      method: 'POST',
      data,
    })
  },

}
export default API